import { Tooltip } from 'antd';
import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Label } from 'recharts';
import { useMediaQuery } from 'react-responsive';
import { useSelector } from 'react-redux';
import CountUp from 'react-countup';



const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const EmployeeOverview = () => { 
  const { personnelSummary } = useSelector((state) => state.dropdown);

  const data = [
    { name: 'Active Employees', value: personnelSummary?.active || 0 },
    { name: 'Inactive Employees', value: personnelSummary?.inActive || 0 },
    { name: 'Retired Employees', value: personnelSummary?.retired || 0 },
  ]; 

  const isSmallScreen = useMediaQuery({ maxWidth: 768 });

  const renderCountUp = (value) => (
    <CountUp end={value} duration={2} />
  );

  return (
    <>
    <div className="product_request_title ">Employees Overview </div>
    <ResponsiveContainer width="100%" height={isSmallScreen ? 200 : 100} >
      <PieChart width={100} height={100}> 
        <Pie
          data={data}
          cx={isSmallScreen ? 150 : 80}  // Move to the left for small screens
          cy={isSmallScreen ? 70 : 80}  // Move upwards for small screens
          startAngle={180}
          endAngle={0}
          innerRadius={isSmallScreen ? 45 : 65}  // Adjust radius for small screens
          outerRadius={isSmallScreen ? 55 : 75}
          fill="#8884d8"
          paddingAngle={5}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie> 
        {isSmallScreen ? (
          <Legend
            layout="horizontal"
            verticalAlign="bottom"
            align="center"
            iconType="line"  
            formatter={(value, entry) => (
              <>
                {renderCountUp(entry.payload.value)} <span style={{ marginLeft: 10 }}>{value}</span>
              </>
            )}
            // formatter={(value, entry) => `${entry.payload.value} \u00A0\u00A0\u00A0\u00A0 ${value}`}
          />
        ) :(
          <Legend 
          layout='vertical'
          verticalAlign='right'
          align='right'
          iconType="line"
          formatter={(value, entry) => (
            <>
              {renderCountUp(entry.payload.value)} <span style={{ marginLeft: 10 }}>{value}</span>
            </>
          )}
          // formatter={(value, entry) => `${entry.payload.value} \u00A0\u00A0\u00A0\u00A0 ${value}`}
          wrapperStyle={{ backgroundColor: '#fff' }} 
       />
        )
      } 
      </PieChart>
    </ResponsiveContainer>
    </>
  );
};

export default EmployeeOverview;
